import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import UserType, { URL_DEFAULT_REDIRECT, UserRoles } from 'src/utils/constants/auth';
import { selectUserRedirectBySystemRol } from 'src/utils/common';

const SuperAdminPrivateRoute = ({ component: Component }) => {
  const loggedIn = useSelector(state => state.auth.token !== null);
  const systemRole = useSelector(state => state.auth.system === UserType.ADMIN);
  const role = useSelector(state => state.auth.role === UserRoles.SUPER_ADMIN);
  const system = useSelector(state => state.auth.system);

  if (!loggedIn) {
    window.location.replace(URL_DEFAULT_REDIRECT);
    return null;
  }

  if (!systemRole || !role) {
    return <Navigate to={selectUserRedirectBySystemRol(system)} replace />;
  }

  return <Component />;
};

SuperAdminPrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func
  ])
};

export default SuperAdminPrivateRoute;
